import { RepeatEndOption, RepeatRuleOption, RepeatUnit, RepeatWeekday } from "./types";

class RepeatRuleSettingModalService {
  constructor() {}

  getRepeatUnitLabel(unit: RepeatUnit): string | null {
    switch (unit) {
      case RepeatUnit.WEEK:
        return "주";
      case RepeatUnit.DAY:
        return "일";
      case RepeatUnit.MONTH:
        return "개월";
      default:
        return null;
    }
  }

  getWeekday(date: Date): RepeatWeekday {
    const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
    return daysOfWeek[date.getDay()] as RepeatWeekday;
  }

  getNthWeekday(date: Date): string {
    const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];

    const dayOfWeek = date.getDay();
    const dayOfMonth = date.getDate();
    const nth = Math.ceil(dayOfMonth / 7);

    return `${nth}번째 ${daysOfWeek[dayOfWeek]}요일`;
  }

  getRRuleString(
    repeatUnit: RepeatUnit,
    interval: number,
    repeatEndOption: RepeatEndOption,
    repeatCount?: number,
    endDate?: Date,
    repeatWeekdays?: string[],
    repeatRuleOption?: RepeatRuleOption,
    repeatRuleDate?: Date
  ): string {
    const rruleParts: string[] = [];

    // Frequency 설정
    switch (repeatUnit) {
      case RepeatUnit.DAY:
        rruleParts.push("FREQ=DAILY");
        break;
      case RepeatUnit.WEEK:
        rruleParts.push("FREQ=WEEKLY");
        break;
      case RepeatUnit.WEEKDAYS:
        rruleParts.push("FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR");
        break;
      case RepeatUnit.MONTH:
        rruleParts.push("FREQ=MONTHLY");
        break;
    }

    // Interval 설정
    rruleParts.push(`INTERVAL=${interval}`);

    // End 설정
    if (repeatEndOption === RepeatEndOption.DATE && endDate) {
      rruleParts.push(`UNTIL=${endDate.toISOString().split("T")[0].replace(/-/g, "")}T000000Z`);
    } else if (repeatEndOption === RepeatEndOption.TIMES && repeatCount) {
      rruleParts.push(`COUNT=${repeatCount}`);
    }

    // RepeatRuleOption 처리
    if (repeatUnit === RepeatUnit.MONTH && repeatRuleOption && repeatRuleDate) {
      if (repeatRuleOption === RepeatRuleOption.NTH_WEEKDAY) {
        // N번째 주의 특정 요일 처리
        const nthWeek = Math.ceil(repeatRuleDate.getDate() / 7); // 몇 번째 주인지 계산
        const weekday = repeatRuleDate.toLocaleString("en-US", { weekday: "short" }).toUpperCase(); // 요일 (MO, TU 등)
        rruleParts.push(`BYDAY=${nthWeek}${weekday}`); // "1MO", "2TU" 등
      } else if (repeatRuleOption === RepeatRuleOption.SPECIFIC) {
        // 특정 날짜 처리
        const dayOfMonth = repeatRuleDate.getDate();
        rruleParts.push(`BYMONTHDAY=${dayOfMonth}`); // "14" 등
      }
    }

    // BYDAY 설정 (주 단위 반복일 경우 요일 지정)
    if (repeatUnit === RepeatUnit.WEEK && repeatWeekdays && repeatWeekdays.length > 0) {
      const weekdays = repeatWeekdays
        .map((day) => {
          switch (day) {
            case RepeatWeekday.MON:
              return "MO";
            case RepeatWeekday.TUE:
              return "TU";
            case RepeatWeekday.WED:
              return "WE";
            case RepeatWeekday.THU:
              return "TH";
            case RepeatWeekday.FRI:
              return "FR";
            case RepeatWeekday.SAT:
              return "SA";
            case RepeatWeekday.SUN:
              return "SU";
            default:
              return "";
          }
        })
        .filter(Boolean)
        .join(",");
      if (weekdays) {
        rruleParts.push(`BYDAY=${weekdays}`);
      }
    }

    return rruleParts.join(";");
  }
}

export default RepeatRuleSettingModalService;
